module.exports=function(scope){ return `-dontwarn javax.annotation.Nullable
-keep class com.facetec.zoom.**
{ *; }
`};


// WEBPACK FOOTER //
// ./src/resources/code/getting-started/proguard.bash.tpl